export default "__VITE_ASSET__DUiIxNrt__"